import { render, staticRenderFns } from "./ChangeModal.vue?vue&type=template&id=2a571ff9&scoped=true&"
import script from "./ChangeModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeModal.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeModal.vue?vue&type=style&index=0&id=2a571ff9&lang=scss&scoped=true&"
import style1 from "./ChangeModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a571ff9",
  null
  
)

export default component.exports